var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zjxPageFooter"},[_c('div',{staticClass:"zjxPageFooter_center"},[_c('div',{staticClass:"zjxFooter_view"},[_c('p',[_vm._v(_vm._s(_vm.basicInfo.copyright_owner)+"    "+_vm._s(_vm.basicInfo.icp)+"    技术支持：新中大科技")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }